import { InventoryBoundary } from '@cibo/core'
import { useQuery } from '@tanstack/react-query'
import { Feature, Geometry } from 'geojson'
import { getBoundaryFeature } from '../getBoundaryFeature'

export const useBoundaryFeature = (boundary?: InventoryBoundary) =>
  useQuery<Feature<Geometry, any> | undefined>(
    ['inventory_boundary_geometry', boundary],
    () => {
      if (!boundary) return undefined
      return getBoundaryFeature(boundary)
    },
    { enabled: !!boundary }
  )
